import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-booking-item-setting-field-pricing-price',
    templateUrl: './editor-booking-item-setting-field-pricing-price.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldPricingPriceComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;

  constructor() {

  }

  ngOnInit() {

  }
}
